export const SET_PAGE_READY = 'SET_PAGE_READY'

export function setPageReady (ready) {
  return {
    type: SET_PAGE_READY,
    payload: ready,
  }
}
